const I18N = {
  en: {
    link: 'https://canada.ca/en.html',
    gc: 'Government of Canada',
  },
  fr: {
    link: 'https://canada.ca/fr.html',
    gc: 'Gouvernement du Canada',
  },
};

export default I18N;
